<template>
    <div id="top-dialog" :class="wrapperClass">
        <div class="dialog alert" :class="typeClass('alert')" v-html="message" @click="clear()"></div>
        <div class="dialog warning" :class="typeClass('warning')" v-html="message" @click="clear()"></div>
        <div class="dialog confirm" :class="typeClass('confirm')">
            <p v-html="message"></p>
            <nav>
                <span class="small black button" v-if="!processing" @click="makeCall">YES</span>
                <span class="small black disabled button" v-if="processing"><i class="fas fa-spinner fa-spin fa-fw"></i></span>
                <span class="small success button" @click="clear">NO</span>
            </nav>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            sessionDialog: {
                type: Object,
                required: false,
                default: () => {
                    return {};
                }
            }
        },
        data() {
            return {
                id: null,
                type: null,
                message: '',
                url: '',
                timeout: null,
                processing: false
            }
        },
        computed: {
            wrapperClass() {
                return {
                    'overlay': this.isVisible() && this.typeIs('confirm')
                };
            }
        },
        mounted() {
            EventHandler.listen('top-alert', this.alertEvent);
            EventHandler.listen('top-warning', this.warningEvent);
            EventHandler.listen('top-confirm', this.confirmEvent);
            if (Object.keys(this.sessionDialog).length) {
                setTimeout(() => {
                    EventHandler.fire(this.sessionDialog.type, {
                        id: 'session-' + this.sessionDialog.type,
                        message: this.sessionDialog.message
                    });
                }, 300);
            }
        },
        methods: {
            alert(data, type) {
                this.clear();
                this.id = data.id;
                this.type = type;
                this.message = data.message;
                this.countDown();
            },
            alertEvent(data) {
                this.alert(data, 'alert');
            },
            warningEvent(data) {
                this.alert(data, 'warning');
            },
            confirmEvent(data) {
                this.clear();
                this.id = data.id;
                this.type = 'confirm';
                this.url = data.url;
                this.message = data.message;
            },
            isVisible() {
                return this.message !== '';
            },
            typeIs(type) {
                return this.type === type;
            },
            typeClass(type) {
                return {
                    'active': this.isVisible() && this.typeIs(type)
                };
            },
            countDown() {
                this.timeout = setTimeout(() => {
                    this.clear();
                }, 7000);
            },
            clear() {
                this.clearCountDown();
                this.type = null;
                this.message = '';
                this.processing = false;
                EventHandler.fire(this.id + '-cleared');
            },
            clearCountDown() {
                if (this.timeout === null) {
                    return;
                }
                clearTimeout(this.timeout);
                this.timeout = null;
            },
            makeCall() {
                this.processing = true;
                window.axios.get(this.url)
                    .then(this.callSuccessful)
                    .catch(this.callFailed);
            },
            callSuccessful(response) {
                EventHandler.fire(this.id + '-called', {
                    response: response,
                    dialog: this
                });
            },
            callFailed(error) {
                this.processing = false;
                if (error.response) {
                    error = 'Error code: ' + error.response.status + ' (' + error.response.statusText + ')';
                } else {
                    error = error.message;
                }
                this.warningEvent({
                    id: this.id,
                    message: error
                });
            }
        }
    };
</script>